export const fetchSprite = () =>
  fetch(`${process.env.PUBLIC_URL}/spritemap.svg`).then((data) => data.text());
